import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonService } from '../service/common.service';
import { AppSettingsService } from '../config/config-service';

export interface ActivityLog {
  _id: string;
  userId?: string | null;
  action: string;
  refType?: string;
  refId?: string;
  message: string;
  ipAddress?: string;
  userAgent?: string;
  createdAt: string;
  updatedAt: string;
  __v?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ActivityLogService {
  private apiUrl: string;

  constructor(
    private http: CommonService,
    private appSettingsService: AppSettingsService
  ) {
    this.apiUrl = this.appSettingsService.getSettings().apiEndPoint || '';
  }

  /**
   * Get activity logs with filtering and pagination
   */
  getActivityLogs(params: {
    page?: number;
    limit?: number;
    search?: string;
    action?: string;
    startDate?: string;
    endDate?: string;
  }): Observable<any> {
    let httpParams = new HttpParams();

    if (params.page) {
      httpParams = httpParams.set('page', params.page.toString());
    }
    if (params.limit) {
      httpParams = httpParams.set('limit', params.limit.toString());
    }
    if (params.search) {
      httpParams = httpParams.set('search', params.search);
    }
    if (params.action) {
      httpParams = httpParams.set('action', params.action);
    }
    if (params.startDate) {
      httpParams = httpParams.set('startDate', params.startDate);
    }
    if (params.endDate) {
      httpParams = httpParams.set('endDate', params.endDate);
    }

    return this.http.get(`${this.apiUrl}/api/activity-logs/list`, { params: httpParams });
  }

  /**
   * Get activity log by ID
   */
  getActivityLogById(logId: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/api/activity-logs/${logId}`);
  }
}
